<template>
  <div class="schedulesmslogVue">
    <!-- Main Body Content area -->
        <div class="o-main-content-area"> 

            <!-- {{ job.calls }} -->
            <!-- Heading Section -->
            <div class="o-page-top-heading c-responsive-fixwidth">
                <div class="row c-responsive-fixwidth">
                    <div class="col-md-6">
                        <p class="u-back"><a href="javascript: void(0)" @click="backToCalender()"><i class="fa fa-chevron-left"></i> Back </a></p>
                    </div>
                    <div class="col-md-6 text-right">
                        <!-- <div class="input-group stylish-input-group">
                            <input type="text" class="form-control" placeholder="Search">
                            <span class="input-group-addon">
                            <button type="submit">
                                <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                            </button>
                            </span>
                        </div> -->
                        <ul v-if="footerAccess()" class="o-filter-area">
                            <li><a href="javascript: void(0)"  @click="goToCalls()" class="c-common-btn c-common-btn--small"><i class="fa fa-eye" aria-hidden="true"></i> View Calls</a></li>
                            <li v-if="userRoleSlug!='employer-admin'"><a href="javascript: void(0)"  @click="goToPhoneSheet()" class="c-common-btn c-common-btn--small"><i class="fa fa-tty" aria-hidden="true"></i> Phone Sheet</a></li>
                            <li><a href="javascript: void(0)" @click="goToJobDetails()" class="c-common-btn c-common-btn--small"><i class="fa fa-briefcase" aria-hidden="true"></i> Job Details</a></li>
                        </ul>
                    </div>
                </div>
                <!-- <div class="row c-responsive-fixwidth">
                    <div class="col-md-12">
                        <h1 class="h1">Event:</h1>
                        <h3 class="h3">CN Event</h3>
                    </div>
                </div> -->
                <div class="c-common-space c-common-space--overflowVisible clearfix">
                    <div class="col-md-12 o-no-padding">
                        <div class="custom-row">
                            <div class="custom-col text-left">
                                <ul class="o-custom-filter-new">
                                    <li><span class="o-blue-medium-text">Jobs / Events: </span> <span>{{job?job.title:''}}</span></li>
                                    <li><span class="o-blue-medium-text">Venue:</span> <span>{{job&&job.venue&&job.venue.name?job.venue.name:'NA'}}</span></li>
                                </ul>
                            </div>
                            <div class="custom-col outer--border text-left">
                                <ul class="o-custom-filter-new">
                                    <li><span class="o-blue-medium-text">Start Date:</span> <span>{{job?getGlobalDate(job.start):''}}</span></li>
                                    <li><span class="o-blue-medium-text">End Date:</span> <span>{{job?getGlobalDate(job.end):''}}</span></li>
                                </ul>
                            </div>
                            <div class="custom-col outer--border text-left">
                                <ul class="o-custom-filter-new">
                                    <li><span class="o-blue-medium-text">Employer:</span> <span>{{(job && job.employer)?job.employer.name:"NA"}}</span></li>
                                    <!-- <li><span class="o-blue-medium-text">Employer-Contact:</span> <span>{{(job && job.employer)?getEmployerUser(job):"NA"}}</span></li> -->
                                    <li><span class="o-blue-medium-text">Payroll:</span> <span>{{(job && job.payroll) ? job.payroll.name : "NA"}}</span></li>
                                </ul>
                            </div>
                            <div class="custom-col outer--border text-left">
                                <ul class="o-custom-filter-new">
                                    <li><span class="o-blue-medium-text">Steward:</span> 
                                        <span >{{job && job.employee && job.employee.employable?job.employee.employable.first_name+" "+job.employee.employable.last_name:'NA'}}</span>
                                    </li>
                                    <li><span class="o-blue-medium-text">Created by:</span> <span>{{(job && job.first_name && job.last_name)? job.first_name+" "+job.last_name : "NA" }}</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <!-- /Heading Section -->
        </div>
        <!-- /Main Body Content area -->

        <!-- Individual calls section area --> 
        <div class="o-ndividualArea c-responsive-fixwidth">
            <!-- <div class="o-ndividualTable" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"> -->
            <div class="o-ndividualTable">
                <div v-if="isPast">
                    <div v-for="(dateWiseCalls, key, index) in calls" :key="key" class="o-ndividualTable">
                        <div v-if="(key!='' && dateWiseCalls.length>0)">
                            <div class="c-common-space o-individual-calls">
                                <div class="col-md-12 o-no-padding">
                                    <h5 :id="'element'+index"  class="h5"><i class="fa fa-calendar-o" aria-hidden="true"></i>{{getDate(key)}}</h5>
                                    <!-- <a @click="openAdvanceClone(key)" class="c-common-btn c-common-btn--small"><i class="fa fa-files-o" aria-hidden="true"></i> Advance Clone</a> -->
                                    <div class="o-customSelect o-custom-dropdown o-inline-block margin-left-md">
                                    <label>Sort by:</label>
                                    <select class="form-control" @change="changeSortType($event)">
                                        <option value="">--- Select ---</option>
                                        <option v-if="checkElementPast('call_times')" value="call_times">Start time</option>
                                        <!-- <option v-if="checkElementPast('call_times')" value="end">End time</option> -->
                                        <option v-if="checkElementPast('position')" value="position">Position</option>
                                        <option v-if="checkElementPast('employee_name')" value="employee_name">Employee Name</option>
                                        <option v-if="checkElementPast('seniority')" value="seniority">Seniority</option>
                                        <option v-if="checkElementPast('call_status')" value="call_status">Status</option>
                                        <option v-if="checkElementPast('confirmed_by')" value="confirmed_by">Confirmed By</option>
                                    </select>
                                    <span class="o-custom-drop-arrow"><i aria-hidden="true" class="fa fa-angle-down"></i></span>
                                    </div>
                                </div>
                            </div>

                            <div v-for="(call, id) in dateWiseCalls" :key="id" class="o-custom-table-container c-common-box-shadow c-radius3 sms-list-table-align o-overflow-visible">
                                <div class="o-calls-table c-common-gradient o-overflow-visible tableList-padding">
                                    <div class="calls-table-row phonesheet-table-row">
                            
                                        <div v-if="checkElementPast('call_times')" class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="calls-table-cell-inner-table">
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <span>Start:</span>
                                                        <div>{{getTime(call.start)}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="checkElementPast('call_times')" class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="calls-table-cell-inner-table">
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <span>End:</span>
                                                        <div>{{getTime(call.end)}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="checkElementPast('position')" class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="calls-table-cell-inner-table">
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <span>Position:</span>
                                                        <div>{{call.skill.name}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="checkElementPast('employee_name')&&checkEmployeeNameColumnPast()" class="calls-table-cell"> {{ }}
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Employee:</span>
                                                    <div v-if="call.status.name !='Unassigned'">
                                                        {{call.employee && call.employee.employable ? call.employee.employable.last_name+", "+call.employee.employable.first_name:''}}
                                                    </div>
                                                    <div v-if="call.status.name =='Unassigned'">{{call.status.name}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else-if="checkElementPast('employee_name')&&(jobTypePast == 'my-job')" class="calls-table-cell"> 
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Employee:</span>                                            
                                                    <!-- <div v-if="checkUserAssignedToCall(call.employee_id)"> -->
                                                    <div v-if="call.status.name !='Unassigned'">
                                                        {{call.employee && call.employee.employable ? call.employee.employable.last_name+", "+call.employee.employable.first_name:''}}
                                                    </div>
                                                    <div v-if="call.status.name =='Unassigned'">{{call.status.name}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="checkElementPast('seniority')" class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Sen:</span>
                                                    <div>
                                                        {{ (call.status.name !='Unassigned' && call.employee && call.employee.seniority && call.employee.seniority != '') ? getRoundOffSkillSeniority(call.employee.seniority):'NA' }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="checkElementPast('notes')" class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Notes:</span>
                                                    <div>{{call.notes.length==0?'---':call.notes}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="checkElementPast('call_status')" class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Status:</span>
                                                    <div>{{call.status.name}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="checkElementPast('confirmed_by')" class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Confirmed By: </span>
                                                    <div v-if="call.status.name=='Confirmed' && call.confirmed_by">{{ call.confirmed_by }}</div>
                                                    <div v-else>---</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="checkElementPast('sms_sent')" class="calls-table-cell">
                                            <div class="">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Notify t/s:</span>
                                                    <div>{{getNotify(call.notified_at, call.marked_at)}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div> 

                <div v-else>
                    <div v-for="(dateWiseCalls, key, index) in calls" :key="key" class="o-ndividualTable">
                        <div v-if="(key!='' && dateWiseCalls.length>0)">
                            <div class="c-common-space o-individual-calls">
                                <div class="col-md-12 o-no-padding">
                                    <h5 :id="'element'+index"  class="h5"><i class="fa fa-calendar-o" aria-hidden="true"></i>{{getDate(key)}}</h5>
                                    <!-- <a @click="openAdvanceClone(key)" class="c-common-btn c-common-btn--small"><i class="fa fa-files-o" aria-hidden="true"></i> Advance Clone</a> -->
                                    <div class="o-customSelect o-custom-dropdown o-inline-block margin-left-md">
                                    <label>Sort by:</label>
                                    <select class="form-control" @change="changeSortType($event)">
                                        <option value="">--- Select ---</option>
                                        <option v-if="checkElementFuture('call_times')" value="call_times">Start time</option>
                                        <!-- <option v-if="checkElementFuture('call_times')" value="end">End time</option> -->
                                        <option v-if="checkElementFuture('position')" value="position">Position</option>
                                        <option v-if="checkElementFuture('employee_name')" value="employee_name">Employee Name</option>
                                        <option v-if="checkElementFuture('seniority')" value="seniority">Seniority</option>
                                        <option v-if="checkElementFuture('call_status')" value="call_status">Status</option>
                                        <option v-if="checkElementFuture('confirmed_by')" value="confirmed_by">Confirmed By</option>
                                    </select>
                                    <span class="o-custom-drop-arrow"><i aria-hidden="true" class="fa fa-angle-down"></i></span>
                                    </div>
                                </div>
                            </div>

                            <div v-for="(call, id) in dateWiseCalls" :key="id" class="o-custom-table-container c-common-box-shadow c-radius3 sms-list-table-align o-overflow-visible">
                                <div class="o-calls-table c-common-gradient o-overflow-visible tableList-padding">
                                    <div class="calls-table-row phonesheet-table-row">
                            
                                        <div v-if="checkElementFuture('call_times')" class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="calls-table-cell-inner-table">
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <span>Start:</span>
                                                        <div>{{getTime(call.start)}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="checkElementFuture('call_times')" class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="calls-table-cell-inner-table">
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <span>End:</span>
                                                        <div>{{getTime(call.end)}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="checkElementFuture('position')" class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="calls-table-cell-inner-table">
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <span>Position:</span>
                                                        <div>{{call.skill.name}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="checkElementFuture('employee_name')&&checkEmployeeNameColumnFuture()" class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Employee:</span>
                                                    <div v-if="call.status.name !='Unassigned'">
                                                        {{call.employee && call.employee.employable ? call.employee.employable.last_name+", "+call.employee.employable.first_name:''}}
                                                    </div>
                                                    <div v-if="call.status.name =='Unassigned'">{{call.status.name}}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-else-if="checkElementFuture('employee_name')&&(jobTypeFuture == 'my-job')" class="calls-table-cell"> 
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Employee:</span>                                            
                                                    <!-- <div v-if="checkUserAssignedToCall(call.employee_id)"> -->
                                                        <div v-if="call.status.name !='Unassigned'">
                                                            {{call.employee && call.employee.employable ? call.employee.employable.last_name+", "+call.employee.employable.first_name:''}}
                                                        </div>
                                                        <div v-if="call.status.name =='Unassigned'">{{call.status.name}}</div>
                                                    <!-- </div> -->
                                                    <!-- <div v-else> -- </div> -->
                                                </div>
                                            </div>
                                        </div>


                                        <div v-if="checkElementFuture('seniority')" class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Sen:</span>
                                                    <div>
                                                        {{ (call.status && call.status.name !='Unassigned' && call.employee && call.employee.seniority && call.employee.seniority!='')?getRoundOffSkillSeniority(call.employee.seniority):'NA'}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="checkElementFuture('notes')" class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Notes:</span>
                                                    <div>{{call.notes.length==0?'---':call.notes}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="checkElementFuture('call_status')" class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Status:</span>
                                                    <div>{{call.status.name}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="checkElementFuture('confirmed_by')" class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Confirmed By:</span>
                                                    <div v-if="call.status.name=='Confirmed' && call.confirmed_by">{{call.confirmed_by}}</div>
                                                    <div v-else>---</div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div v-if="checkElementFuture('sms_sent')" class="calls-table-cell">
                                            <div class="">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Notify t/s:</span>
                                                    <div>{{getNotify(call.notified_at, call.marked_at)}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                
                </div> 

                <div v-if="calls.length == 0">
                    <div class="o-ndividualTable">
                        <div class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
                            <div class="col-md-12 no-job-dispaly" style="font-size: 20px;">
                                <!-- <i class="fa fa-frown-o" aria-hidden="true"></i>
                                <br />
                                There are currently no calls to be notified or confirmed  -->
                                Please Stand By<br />
                                We are looking for your next job<br />
                                Check Back Soon<br />
                            </div>
                        </div>
                    </div>
                </div>                                             
            </div>          
        </div>

        <!-- /Individual calls section area -->
  </div>
</template>

<script>
    import { VueEditor } from 'vue2-editor';
    import service from '../../services.js';
    // import { global } from '../../global.js';
    import dateTimeConvert from '../../timeConvert&Compare';
    import { mapGetters } from 'vuex';
    export default {
        components: {
            VueEditor
        },
        data() {
            return {
                callSettingsPast:{},
                callSettingsFuture:{},
                calls:[],
                lastDate:'',
                afterAPI:'',
                storeMore:[],
                job:null,
                isPast:true,
                showEmployeeName: false,
                jobTypePast: '',
                jobTypeFuture: '',
                dummyCalls:[]
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userRoleSlug: 'userRoleSlug',
                employeeId: 'employeeId',
                userID: 'userID'
            })
        },
        methods: {
            getEmployerUser(modalJob) {
                let employer_user = 'NA';
                // console.log(modalJob.employer_user_id)
                // let employer_user_id = modalJob.employer_user_id;
                for(let i=0;i<modalJob.employer.employer_users.length;i++) {
                    if(modalJob.employer.employer_users[i].user_id == modalJob.employer_user_id) {
                        employer_user = modalJob.employer.employer_users[i].user.first_name + ' ' + modalJob.employer.employer_users[i].user.last_name;
                        break;
                    }
                }
                return employer_user;
            },
            getRoundOffSkillSeniority(seniorityVal) {     
                // console.log(seniorityVal); 
                if(seniorityVal && seniorityVal != '') {          
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            },

            checkElement(value){
                if(this.isPast){
                    for (var key in this.callSettingsPast) {
                        if(this.callSettingsPast[key]==value){
                            return true;
                        }
                    }
                }else{
                    for (var key in this.callSettingsFuture) {
                        if(this.callSettingsFuture[key]==value){
                            return true;
                        }
                    }
                }
                return false;
            },

            checkElementPast(value){
                if(this.isPast){
                    for (var key in this.callSettingsPast) {
                        if(this.callSettingsPast[key]==value){
                            return true;
                        }
                    }
                }
                return false;
            },

            checkElementFuture(value){
                if(!this.isPast){
                    for (var key in this.callSettingsFuture) {
                        if(this.callSettingsFuture[key]==value){
                            return true;
                        }
                    }
                }
                return false;
            },

            checkUserAssignedToJob() {                
                let jobCalls = this.job && this.job.calls && this.job.calls.length ? this.job.calls : [];
                if(jobCalls && jobCalls.length) {
                    for(let i=0; i<jobCalls.length; i++) {
                        if(jobCalls[i].employee_id && jobCalls[i].employee_id == this.employeeId) {
                            return true;

                        }
                    }
                }
                return false;
            },

            checkUserAssignedToCall(id) {
                // console.log(id);
                // console.log(this.employeeId);
                if(id == this.employeeId) {
                    return true;
                }                    
               return false;
            },

            checkEmployeeNameColumn() {
                // console.log(this.jobTypeFuture);
                if(this.jobTypeFuture == 'all-job' || this.jobTypePast == 'all-job') { 
                    // console.log(this.jobTypeFuture, this.jobTypePast)
                    return true; 
                } else if((this.jobTypeFuture == 'my-crew' || this.jobTypePast == 'my-crew') && this.checkUserAssignedToJob()){
                    // console.log(this.jobTypeFuture, this.jobTypePast)
                    return true;
                }
                return false;
            },

            checkEmployeeNameColumnPast() {
                if(this.jobTypePast == 'all-job') { 
                    // console.log(this.jobTypePast);
                    return true; 
                } else if(( this.jobTypePast == 'my-crew') && this.checkUserAssignedToJob()){
                    // console.log(this.jobTypeFuture, this.jobTypePast)
                    return true;
                }
                return false;
            },

            checkEmployeeNameColumnFuture() {
                if(this.jobTypeFuture == 'all-job') { 
                    return true; 
                } else if((this.jobTypeFuture == 'my-crew') && this.checkUserAssignedToJob()){
                    // console.log(this.jobTypeFuture);
                    // console.log("true");
                    return true;
                }
                return false;
            },

            backToCalender(){
                this.$router.go(-1);
                // this.$router.push({
                //     path: `/calendar`
                // });
            },

            goToCalls(){
                this.$store.dispatch('setSelectedCallList', 'bulk');
                if(this.userRoleSlug != 'employer-admin') {
                    this.$router.push({
                        path: `/viewCalls/`+ this.$route.params.jobId
                    });
                }else {
                    this.$router.push({
                        path: `/viewCallsEmployer/`+ this.$route.params.jobId
                    });
                }
            },

            goToPhoneSheet(){
                this.$router.push({
                    path: `/phoneSheet/`+ this.$route.params.jobId
                });
            },

            goToJobDetails(){
                if(this.userRoleSlug != 'employer-admin') {
                    this.$router.push({
                        path: `/jobDetails/`+ this.$route.params.jobId
                    });
                } else {
                     this.$router.push({
                        path: `/employerJobDetails/`+ this.$route.params.jobId
                    });
                }
            },

            footerAccess(){
              if(this.userRoleSlug=='employee')
                return false;
              else
                return true;
            },

            changeSortType(e){
                // console.log(e.target.value);
                this.sortCalls(e.target.value);
            },

            sortCalls(type) {
                this.calls=this.dummyCalls;
                let self = this;
                switch (type) {
                    case 'call_times':
                        for (let key in this.calls) {
                            this.calls[key].sort(function(a, b) {
                                var dateA = moment(a.start);
                                var dateB = moment(b.start);
                                return dateA > dateB ? 1 : -1;
                            });
                        }
                        // console.log("call_times", type, this.calls);
                        break;

                    case 'call_status':
                        for (let key in this.calls) {
                            this.calls[key].sort(function(a, b) {
                                if (a.status.name < b.status.name) return 1;
                                if (a.status.name > b.status.name) return -1;
                                return 0;
                            });
                        }
                        // console.log("call_status", type, this.calls);
                        break;
                        
                    case 'position':
                        for (let key in this.calls) {
                            this.calls[key].sort(function(a, b) {
                                //console.log("Skill..",a.skill.name);
                                if (a.skill.priotiy < b.skill.priotiy) return -1;
                                if (a.skill.priotiy > b.skill.priotiy) return 1;
                                return 0;
                            });
                        }
                        // console.log("position", type, this.calls);
                        break;

                    case 'seniority':
                        for (let key in this.calls) {
                            this.callsBySorting[key].sort(function(a, b) {
                                if (a.status.name == "Unassigned") return 1;
                                if (a.status.name == 'Unconfirmed' || a.status.name == 'Confirmed' || b.status.name == 'Unconfirmed' || b.status.name == 'Confirmed') return -1;
                                return 0;
                            });
                        }
                        
                        let calls = this.calls;

                        for (let key in calls) {   
                            calls[key].forEach((item) => {
                                if((item.employee && !item.employee.seniority)||(item.employee && item.employee.seniority == '')) {
                                    item.employee.seniority = 0;
                                }else {
                                    if(item.employee){
                                        item.employee.seniority = parseFloat(item.employee.seniority);
                                    }
                                }                        
                            });
                        }

                        for (let key in calls) {
                            calls[key].sort((a, b) => {
                                if(a.status.name == 'Unassigned') {
                                    return -1;
                                } else if(a.employee) {
                                    if(a.employee["seniority"] && a.employee["seniority"]!='' && a.employee["seniority"]>=0 && b.employee && b.employee["seniority"] && b.employee["seniority"]!='' && b.employee["seniority"]>=0) {
                                        if (parseFloat(a.employee.seniority) > parseFloat(b.employee.seniority)) return 1;
                                        if (parseFloat(a.employee.seniority) < parseFloat(b.employee.seniority)) return -1;
                                        if (a.employee.seniority == b.employee.seniority) {
                                            if(a.employee.employable && a.employee.employable.last_name && b.employee.employable && b.employee.employable.last_name) {
                                                var nameA = a.employee.employable.last_name.toUpperCase(); // ignore upper and lowercase
                                                var nameB = b.employee.employable.last_name.toUpperCase(); // ignore upper and lowercase
                                                if (nameA < nameB) {
                                                    return -1;
                                                }
                                                if (nameA > nameB) {
                                                    return 1;
                                                }
                                            }
                                        }
                                    } else {
                                return -1;
                                    }
                                } else {
                                    return -1;
                                }
                                // return 0;
                            });
                        }
                        this.calls = calls;

                        // console.log('Check');
                        // for (let key in this.calls) {
                        //     this.calls[key].sort(function(a, b) {
                        //         if(a.employee && a.employee["seniority"]&&a.employee["seniority"]!=''&&b.employee&&b.employee["seniority"]&&a.employee["seniority"]!=''){
                        //             if (parseFloat(a.employee.seniority) < parseFloat(b.employee.seniority)) return -1;
                        //             if (parseFloat(a.employee.seniority) > parseFloat(b.employee.seniority)) return 1;
                        //             return 0;
                        //         }
                        //         return -1;
                        //     });
                        // }
                        // console.log("seniority", type, this.calls);
                        break;
                    case 'employee_name':
                        for (let key in this.calls) {
                            this.calls[key].sort(function(a, b) {
                                let nameA = a.employee && a.employee["employable"] ? a.employee.employable.last_name+' '+a.employee.employable.first_name:'zzzzzz';
                                let nameB = b.employee && b.employee["employable"] ? b.employee.employable.last_name+' '+b.employee.employable.first_name:'zzzzzz';
                                if (nameA < nameB) return -1;
                                if (nameA > nameB) return 1;
                                return 0;
                            });
                        }
                        // console.log("employee_name", type, this.calls);
                        break;
                    default:
                        //console.log("default case..");
                }
            },

            getAllCalls() {
                this.$Progress.start();
                console.log("Check");
                service.get('job/' + atob(this.$route.params.jobId) + '/call', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'source': 'calendar-job-call'
                }).then((res) => {
                        //console.log("res.data.result", res.data.result);
                    this.calls = res.data.result;
                    this.dummyCalls = res.data.result;
                    // this.showEmployeeName = this.calls['0'].show_employee;
                    // console.log(this.showEmployeeName);
                    //bus.$emit('onUpdateCallList', this.calls);
                    this.$Progress.finish();
                    //this.sortCalls();
                    this.afterAPI = true;
                    //console.log(res);
                    this.lastDate = Object.keys(this.calls)[Object.keys(this.calls).length - 1] + " " + Date().slice(16, 24);
                    // service.get('job/' + atob(this.$route.params.jobId) + '/call', {
                    //     'Authorization': this.userToken,
                    //     'cs3-context-role': this.userRole,
                    //     'cs3-context-clientId': this.userClientID,
                    //     'nextDate': this.lastDate,
                    // }).then((res) => {
                    //     this.storeMore = res.data.result;
                    //     //console.log(this.storeMore);
                    //     if (this.storeMore.length != 0) {
                    //         this.lastDate = Object.keys(this.storeMore)[Object.keys(this.calls).length - 1] + " " + Date().slice(16, 24);
                    //     } else {
                    //         this.lastDate = '';
                    //     }                                    
                    // }).catch((err) => {
                    //     console.log(err);
                    // });
                }).catch((err) => {
                    console.log(err);
                    this.afterAPI = true;
                    this.$Progress.finish();
                    if(err.response&&err.response.status&&err.response.status==403) {
                        this.isEmployeeAllowed = false;
                        this.$notify({
                            title: 'Important message',
                            message: "You don't have Access!",
                            type: 'error'
                        });
                        this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
                    }else {
                        this.$notify({
                            title: 'Error',
                            message: "Something went wrong!",
                            type: 'error'
                        });
                    }
                });
            }, 

            loadMore() {
                console.log("Check load more");
                if (this.storeMore.length != 0) {
                    this.calls = Object.assign({}, this.calls, this.storeMore);
                    //bus.$emit('onUpdateCallList', this.calls);
                    this.storeMore = [];
                    if (this.lastDate != '') {
                        service.get('job/' + atob(this.$route.params.jobId) + '/call', {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'nextDate': this.lastDate,
                        })
                        .then((res) => {
                            this.storeMore = res.data.result;
                            if (this.storeMore.length != 0) {
                                this.lastDate = Object.keys(this.storeMore)[Object.keys(this.calls).length - 1] + " " + Date().slice(16, 24);
                            } else {
                                this.lastDate = '';
                            }
                        }).catch((err) => {
                            console.log(err);
                        })
                    } else {
                        this.storeMore = [];
                    }
                }
            }, 

            getDate(dateTime) {
                return dateTimeConvert.extractDateOnly(dateTime);
            },

            getGlobalDate(dateTime){
                return dateTimeConvert.globalDate(dateTime);
            },

            getTime(dateTime) {
                return dateTimeConvert.globalTime(dateTime);
            },

            getNotify(notified, marked){
                if(notified && marked){
                    if(moment(notified)>moment(marked)){
                        return dateTimeConvert.utcTimeToUserTime(notified);
                    }
                    return dateTimeConvert.utcTimeToUserTime(marked);
                }else if(marked){
                    return dateTimeConvert.utcTimeToUserTime(marked);
                }else if(notified){
                    return dateTimeConvert.utcTimeToUserTime(notified);
                }
                return "---"
            },

            getClientSettings(){
                console.log(this.userRoleSlug);
                let client_id = '';
                if(this.userRoleSlug == 'employer-admin') {
                    client_id = atob(this.$route.query.client);
                }else {
                    client_id = this.userClientID
                }

                if(client_id != '') {
                    service.get('client/' + client_id, {
                        'Authorization': this.userToken
                    })
                    .then((client) => {
                        this.callSettingsPast=client.data.result.settings['job-info-config-past'];
                        this.callSettingsFuture=client.data.result.settings['job-info-config-future'];
                        
                        let jobTypeFuture = client.data.result.settings['job-type-future'];
                        let jobTypePast=client.data.result.settings['job-type-past'];
                        this.jobTypeFuture = jobTypeFuture[0];
                        this.jobTypePast = jobTypePast[0];
                        this.empSort = client.data.result.default_employee_sort;
                        // console.log(this.callSettings);
                        // for (var key in this.callSettings) {
                        //     if(this.callSettings[key]=='position'){
                        //         console.log('true');
                        //     }
                        //     //console.log("User " + this.callSettings[key] + " is #" + key); // "User john is #234"
                        // }
                        
                    }).catch((err) => {
                        console.log(err);
                        this.$notify.error({
                            title: 'Error',
                            message: 'Something went wrong!'
                        })
                    })
                }else {
                    console.log("Client_id is missing");
                    this.$notify.error({
                        title: 'Error',
                        message: 'Something went wrong!'
                    })
                }
            },

            async jobDetails() {
                this.$Progress.start();
                await service.get('job/' + atob(this.$route.params.jobId), {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'source': 'calendar-job-call'
                }).
                then((res) => {
                    // console.log("Job details", res);
                    this.$store.dispatch('setJob', res.data.result);
                    this.job = res.data.result;
                    this.jobStatus=this.job.status.name;
                    this.notes = res.data.result.notes;
                    this.attachmentList = res.data.result.attachments;

                    this.jobStart = new Date(this.job.start);
                    this.jobStart.setDate(this.jobStart.getDate() - 1);
                    this.jobEnd = new Date(this.job.end);
                    this.checkJob(this.job.end);
                    this.$Progress.finish();
                    // console.log(this.notes);
                    // setTimeout(() => {
                    //     this.getRefs(this.job.venue);
                    // }, 2000);

                }).catch((err) => {
                    console.log(err);
                });
            },

            checkJob(endDate){
                // console.log(endDate);
                if(moment(endDate).format('YYYY-MM-DD')<moment().format('YYYY-MM-DD')){
                    this.isPast=true;
                }else{
                    this.isPast=false;
                }
            },
        },

        async mounted() {
            await this.jobDetails();
            this.getClientSettings();   
            this.getAllCalls(); 
        }
    }

</script>
<style scoped>
.o-main-content-area {
    padding: 75px 30px 0px 50px;
}
.o-custom-filter-new{
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/calendar/calendarJobCall.vue